import React from 'react';

import { Image } from '@depop/web-thrift-ui/Icons/Image';
import { Body, Caption } from '@depop/web-thrift-ui/Typography';
import { useTranslations } from 'next-intl';

import styles from './styles.module.css';

import { ExtendedLink } from '@/components/ExtendedLink';
import { FeedbackStars } from '@/components/FeedbackStars';
import { getFeedbackDate } from '@/modules/feedback/helpers';
import { type FeedbackItem } from '@/modules/feedback/types';
import { getLargestPictureFormatFromObject } from '@/modules/images/helpers';
import { createSrcSet } from '@/modules/pictures/helpers';

type Props = FeedbackItem;

export function FeedbackModalRow({
  product,
  author,
  date,
  rating,
  text,
}: Props) {
  const t = useTranslations('common');
  const hasPreview = Object.keys(product.preview).length > 0;

  return (
    <div className={styles.container}>
      {hasPreview ? (
        <img
          className={styles.image}
          src={getLargestPictureFormatFromObject(product.preview)}
          srcSet={createSrcSet(product.preview)}
          alt=""
        />
      ) : (
        <div
          className={styles.imagePlaceholder}
          role="img"
          aria-label={t('FeedbackProductImageUnavailable')}
        >
          <Image size="md" />
        </div>
      )}
      <div>
        <ExtendedLink className={styles.username} href={`/${author.username}/`}>
          <Body variant="sm-bold">@{author.username}</Body>
        </ExtendedLink>
        <div className={styles.ratingContainer}>
          <FeedbackStars rating={rating} />
        </div>
      </div>
      <Body variant="sm-regular">{text}</Body>
      <Caption variant="lg-regular">{getFeedbackDate(date)}</Caption>
    </div>
  );
}
